module.exports = __webpack_public_path__ + "img/logo.9e182117.svg";